import $ from 'jquery'
import misc from './misc'
import user from './user'
import store from '@/store'

export const ready = () => {
    return !!store.getters['peer/isInitiated']
}

export const admin = (type) => {
    let types = ['GBCIADMIN', 'USGBCADMIN', 'GBCICBADMIN']
    let userType = user.getInfo().userType
    let result = $.inArray(userType, types) !== -1
    
    if(!result)
        return result
    
    if(!type)
        return result
    
    switch(type) {
    case 'gbci':
        return userType === 'GBCIADMIN'
    
    case 'usgbc':
        return userType === 'USGBCADMIN'
    
    case 'cb':
        return userType === 'GBCICBADMIN'
    }
    
    return false
}

export const reviewer = (type) => {
    let types = ['GBCICBADMIN', 'CBADMIN', 'CBUSER']
    let userType = user.getInfo().userType
    let result = $.inArray(userType, types) !== -1
    
    if(!result)
        return result
    
    if(!type)
        return result
    
    switch(type) {
    case 'gbci':
        return userType === 'GBCICBADMIN'
    
    case 'admin':
        return userType === 'CBADMIN'
    
    case 'cb':
        return userType === 'CBUSER'
    }
    
    return false
}

export const endUser = () => {
    return user.getInfo().userType === 'SITEUSER'
}

export const value = (path, obj) => {
    path = path.split('.')
    
    if(!path[1])
        return typeof obj[path[0]] !== 'undefined' ?misc.boolToStr(obj[path[0]]) :null
    
    obj = $.extend(true, {}, obj)
    
    for(let i=0; i<path.length; i++) {
        if(typeof obj[path[i]] !== 'undefined')
            obj = obj[path[i]]
        else
            return null
    }
    
    return misc.boolToStr(obj)
}

export const empty = (d) => {
    return d === ''
        || d === undefined || d === 'undefined'
        || d === null || d === 'null'
}

export const ie = () => {
    return /Trident|MSIE/.test(navigator.userAgent)
}

export default {
    admin, reviewer, endUser,
    value, empty, ready, ie
}
